/**
 * ChangedFieldHighlight - Amber-highlighted wrapper for a changed field.
 *
 * Shows the field label + change indicator + children (value display)
 * inside an amber background.
 *
 * Simplified version without transfer checkboxes.
 */

import type { ChangedFieldsInfo } from '../utils/useChangedFields';
import { ChangedFieldIndicator } from './ChangeIndicators';

interface ChangedFieldHighlightProps {
  label: string;
  fieldKey: string;
  changes: ChangedFieldsInfo;
  children: React.ReactNode;
}

export const ChangedFieldHighlight: React.FC<ChangedFieldHighlightProps> = ({
  label,
  fieldKey,
  changes,
  children,
}) => (
  <div className="rounded bg-amber-50/60 px-1 py-0.5">
    <div className="flex items-center gap-1 mb-0.5">
      <span className="text-xs text-gray-400">{label}:</span>
      <ChangedFieldIndicator
        oldValue={changes.getOldValue(fieldKey)}
        label={label}
      />
    </div>
    {children}
  </div>
);
